import { getLocalizationStore } from '../../../../core/src';
import { LocalizationData } from '../../../../../core/src';

export function getLocalization(app: any): LocalizationData {
  const localizationStore = getLocalizationStore()
  const language = app.localizationSelector.language
  const localization = localizationStore.get(language);
  if (!localization) return {}
  return localization;
}